import Cookies from "js-cookie";
import Axios from "../../../networking/interceptor";

import { createAsyncThunk } from "@reduxjs/toolkit";
import { oat_driver_login } from "../../../networking/urlEndPoints";
import { authSelectedPharmacy } from "./authSelectedPharmacy";

import { fetchPharmacyDetails } from "../dispense/getPharmacyDetail";
import { getActivityStatus } from "../../slices/chat/activityStatus";

import * as routeNames from '../../../routes/routeName';
import * as Storage from '../../../storage'

export const authLogin = createAsyncThunk('authLogin', async (userDetail, { rejectWithValue }) => {

	try {

		const requesteData = {
			email: userDetail?.email,
			password: userDetail?.password,
			passcode: userDetail?.passcode
		}

		const response = await Axios.post(oat_driver_login, requesteData);
		const data = response.data;

		Cookies.set('authToken', data?.data?.token)
		Cookies.set('verified', 0)

		if (typeof userDetail.navigate === 'function') {

			if (data?.data?.pharmacist_profile?.pharmacy) {
				localStorage.removeItem(Storage.todayMissedRoute)
				localStorage.removeItem(Storage.finalMissedRoute)
				localStorage.removeItem(Storage.todayPendingRoute)

				userDetail.dispatch(getActivityStatus({ status: 'online' }))

				if (data?.data?.pharmacist_profile?.pharmacy?.send_driver_delivery_otp === 1) {
					userDetail.dispatch(authSelectedPharmacy(data?.data?.pharmacist_profile?.pharmacy))
					userDetail.dispatch(fetchPharmacyDetails(data?.data?.pharmacist_profile?.pharmacy?.id))
					userDetail.navigate(`${routeNames.verify_otp}`)
				} else {
					userDetail.dispatch(authSelectedPharmacy(data?.data?.pharmacist_profile?.pharmacy))
					userDetail.dispatch(fetchPharmacyDetails(data?.data?.pharmacist_profile?.pharmacy?.id))
					userDetail.navigate(`${routeNames.DASHBOARD_PHARMACY}`)
				}
			}
		}

		return data;

	} catch (error) {
		return rejectWithValue(error.response)
	}

})